$(document).ready(function () {
    if($('.product-details-tab__nav li').length > 0) {
        // initialize first tab to show content and set nav to active
        $('.product-details-tab__nav li:first-child').addClass('active');
        $('.'+$('.product-details-tab__nav li:first-child').attr('rel')).addClass('active');

        // add click event on tab nav
        $('.product-details-tab__nav li').each(function() {
            $(this).on('click', function() {
                $('.product-details-tab__nav li').removeClass('active');
                $('.product-details-tab__item').removeClass('active');
                $('.'+$(this).attr('rel')).addClass('active');
                $(this).addClass('active');
            });
        });
    }

    $('.collections-tab__nav li').each(function() {
        $(this).on('click', function() {
            $('.collections-tab__nav li').removeClass('active');
            $('.collections-tab__item').removeClass('active');
            $('#'+$(this).attr('rel')).addClass('active');
            $(this).addClass('active');
        });
    });

    $('.product-details-tab .tab-title').each(function() {
        $(this).on('click', function() {
            if($(this).hasClass('open')) {
                $(this).removeClass('open');
            } else {
                $(this).addClass('open');
            }
        });
    });

    if($('.contact-form-field.required').length > 0) {
        $('.contact-form-field.required input').each(function() {
            $(this).on('focus', function() {
                $(this).siblings('label').hide();
            });

            $(this).on('blur', function() {
                if ($(this).val().length == 0)
                    $(this).siblings('label').show();
            });
        });

        $('.contact-form-field.required select').each(function() {
            if($(this).val() == 0) {
                $(this).siblings('label').show();
                $(this).attr('style','text-indent: -9999px;');
            }

            $(this).on('change', function() {
                if($(this).val() == 0) {
                    $(this).siblings('label').show();
                    $(this).attr('style','text-indent: -9999px;');
                } else {
                    $(this).siblings('label').hide();
                    $(this).attr('style','text-indent: 0;');
                }
            });
        });
    }

    $('.smooth-scroll').on('click', function(evt) {
        evt.preventDefault();
        $('html, body').animate(
            { scrollTop: $($(this).attr('href')).offset().top },
            1000
        );
    });


    // Events Page - Slide on button click
    $('.event__slidebutton').on('click', function(evt) {
        evt.preventDefault();
        $('html, body').animate(
            { scrollTop: $('.index-section').offset().top - 100 },
            1000
        );
    });
    
    if($('.product__thumbs').length > 0) {
        if($('.product__thumbs .product__thumb-item').length == 0) {
            $('.pswp__button--arrow--left, .pswp__button--arrow--right').addClass('hide');
        }
    }

    initCollectionDescription();

    initSortBy();
  
  
  function update_variant_option() {
    
    if( $('.product-form .variant-input-wrap select > option').length <= 1 ) {
      return;
    }

    var qty = $('.product-form .js-qty__num').val();
    
    $('.product-form .variant-input-wrap select option').attr('selected', false).change();
    
    if(qty >= 6 ) {
      $('.product-form .variant-input-wrap select option[value="6+"]').attr('selected', 'selected').change();
      $('.product-price h3 .product__price--original').addClass('hide');
      $('.product-price h3 .product__price--sale').removeClass('hide');
      $('.product-price h3 .product__price--before').removeClass('hide');
      $('.product-banner .six-less').addClass('hide');
      $('.product-banner .six-plus').removeClass('hide');
    } else {
      $('.product-form .variant-input-wrap select option[value="1+"]').attr('selected', 'selected').change();
      $('.product-price h3 .product__price--original').removeClass('hide');
      $('.product-price h3 .product__price--sale').addClass('hide');
      $('.product-price h3 .product__price--before').addClass('hide');
      $('.product-banner .six-less').removeClass('hide');
      $('.product-banner .six-plus').addClass('hide');
    }
  }
  
  
  // Product Switch Bulk Volume
  if( $('body').hasClass('template-product') ) {
  	update_variant_option();
	                   
    $(document).on('input', '.product-form .js-qty__num', function() {
      update_variant_option();
    }); 
    
    $('.js-qty__adjust').on('click', function() {
      update_variant_option();
    }); 
  }
  
  
  
  
});

function initCollectionDescription () {
    if($('.collection-description').length > 0) {
        if($('.collection-description').height() < 160) {
            $('.collection-description .show-more').hide();
        } else {
            $('.collection-description .show-more').show();
        }
    }

    $('.show-more').on('click', function() {
        if($(this).hasClass('show-less')) {
            $(this).removeClass('show-less');
            $(this).html('<h4>Læs mere</h4>');
            $('.collection-description').attr('style','');
        } else {
            $(this).addClass('show-less');
            $(this).html('<h4>Vis mindre</h4>');
            $('.collection-description').attr('style','max-height: none;');
        }
    });
}

function initSortBy () {
    if($('#SortBy').length > 0) {
        $('.sort-value').text($('#SortBy option[selected]').text());
    }
}
